import { topicTags } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const sizeClass: Record<string, string> = {
  lg: "px-5 py-3 text-base md:text-lg font-medium",
  md: "px-4 py-2.5 text-sm md:text-base",
  sm: "px-3.5 py-2 text-xs md:text-sm",
};

export default function TopicWall() {
  return (
    <section id="topic-wall" className="w-full px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        kicker="Topic Wall"
        title="话题墙 · 标签即入口"
        desc="把今天散落的瓜点收成一面墙，标签越大，讨论越集中。点开就能顺着话题往下看。"
      />

      <div className="mt-10 flex flex-wrap gap-3 md:gap-4">
        {topicTags.map((tag) => (
          <a
            key={tag.label}
            href="#top-ranking"
            className={`flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-100 text-secondary-900 transition-colors hover:border-accent-300 hover:bg-accent-100 ${sizeClass[tag.size]}`}
          >
            <span className="whitespace-nowrap">{tag.label}</span>
            <span className="whitespace-nowrap rounded-full bg-background-50/70 px-2 py-0.5 font-label text-[11px] text-accent-800">
              {tag.count}
            </span>
          </a>
        ))}
      </div>

      <div className="mt-10 flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:flex-row md:items-center md:justify-between md:p-6">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-800">
            <i className="ri-price-tag-3-line text-lg" />
          </span>
          <div>
            <p className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
              这面墙每 30 分钟补一次标签
            </p>
            <p className="text-xs text-foreground-600">新话题从底部加入，热度高的会自动往上排。</p>
          </div>
        </div>
        <a
          href="#most-discussed"
          className="flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-secondary-600"
        >
          看讨论最多
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-sm" />
          </span>
        </a>
      </div>
    </section>
  );
}